var _g, _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleMaps(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_21_29)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 36,
    width: 180,
    height: 180,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 36.5,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "#D9D9D9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.5 109.462L173.499 109.689C173.499 109.785 173.498 109.88 173.497 109.976C173.499 110.088 173.5 110.2 173.5 110.314C173.5 128.142 159.366 143.923 149.909 154.484C147.165 157.548 144.814 160.173 143.316 162.28C137.99 169.777 135.179 177.898 134.439 181.022C134.439 183.374 132.452 185.281 130 185.281C127.548 185.281 125.561 183.374 125.561 181.022C124.821 177.898 122.01 169.777 116.684 162.28C115.186 160.173 112.835 157.548 110.091 154.484C100.634 143.923 86.5 128.142 86.5 110.314C86.5 110.2 86.5011 110.088 86.5033 109.976C86.5011 109.805 86.5 109.634 86.5 109.462C86.5 86.4078 105.975 67.7188 130 67.7188C154.025 67.7188 173.5 86.4078 173.5 109.462ZM130 124.796C139.316 124.796 146.867 117.549 146.867 108.61C146.867 99.6706 139.316 92.4239 130 92.4239C120.684 92.4239 113.133 99.6706 113.133 108.61C113.133 117.549 120.684 124.796 130 124.796Z",
    fill: "#34A851"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.636 90.2617C163.309 80.4126 154.013 72.8582 142.78 69.5504L117.798 97.438C120.869 94.3494 125.201 92.4253 130.001 92.4253C139.317 92.4253 146.868 99.6722 146.868 108.611C146.868 112.258 145.612 115.623 143.491 118.33L168.636 90.2617Z",
    fill: "#4285F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.594 155.049C110.427 154.862 110.259 154.675 110.089 154.486C103.855 147.524 95.5894 138.295 90.679 127.706L116.645 98.7221C114.442 101.457 113.131 104.888 113.131 108.612C113.131 117.551 120.683 124.799 129.998 124.799C134.717 124.799 138.983 122.939 142.045 119.942L110.594 155.049Z",
    fill: "#F9BB0E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7925 82.4975C90.3719 89.7716 86.5 99.1833 86.5 109.463C86.5 109.634 86.5011 109.806 86.5033 109.977C86.5011 110.088 86.5 110.201 86.5 110.314C86.5 116.391 88.1419 122.23 90.6808 127.704L116.603 98.7691L96.7925 82.4975Z",
    fill: "#E74335"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M142.778 69.5492C138.737 68.3594 134.446 67.7188 129.998 67.7188C116.686 67.7188 104.77 73.4572 96.7909 82.4971L116.601 98.7686L116.644 98.7205C117.005 98.2732 117.389 97.8441 117.795 97.4359L142.778 69.5492Z",
    fill: "#1A73E6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_21_29",
    x: 0,
    y: 0,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21_29"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_21_29",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMaps);
export default __webpack_public_path__ + "static/media/google-maps.815ae690c8fb1d79bb79510fa473b268.svg";
export { ForwardRef as ReactComponent };